/**
 * DevExtreme (ui/date_box/ui.date_box.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var registerComponent = require("../../core/component_registrator"),
    DateBoxMask = require("./ui.date_box.mask");
registerComponent("dxDateBox", DateBoxMask);
module.exports = DateBoxMask;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/date_box/ui.date_box.js
// module id = ../../../../devextreme/ui/date_box/ui.date_box.js
// module chunks = common